import React, { forwardRef, useMemo } from 'react';

import {
    IndentContainer,
    RounderContainer,
} from '@r1-frontend/ui-react/experimental/containers';
import { createCornerMap } from '@r1-frontend/ui-react/experimental/tooltip/helpers';
import { TooltipArrow } from '@r1-frontend/ui-react/experimental/tooltip/TooltipArrow';
import { ITooltipBodyProps } from '@r1-frontend/ui-react/experimental/tooltip/types';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

const TooltipBody = forwardRef<HTMLDivElement, ITooltipBodyProps>(({
    content,
    position = 'top-center',
    withArrow = true,

    background = COLORS.Control,
    arrowIndent = 16,
    radius = 8,
    zIndex,

    className,
}, ref) => {
    const arrowDirection = useMemo(() => {
        switch (true) {
            case position === 'left':
                return 'left';
            case position === 'right':
                return 'right';
            case position.startsWith('top'):
                return 'top';
            default:
                return 'bottom';
        }
    }, [position]);

    return (
        <ST.TooltipContainer
            className={className}
            zIndex={zIndex}
            ref={ref}
            $direction={['left', 'right'].includes(position) ? 'row' : 'column'}
            $reverse={['top-center', 'top-left', 'top-right', 'left'].includes(position)}
            $size={0}
        >
            {
                withArrow && <ST.TooltipArrowContainer
                    $united={createCornerMap({
                        position,
                        onCornerLeft: [0, 0, 0, arrowIndent],
                        onCornerRight: [0, arrowIndent, 0],
                        onDefault: [0],
                    })}
                    position={position}
                    data-test={'tooltip-arrow'}
                >
                    <TooltipArrow
                        color={background}
                        direction={arrowDirection}
                    />
                </ST.TooltipArrowContainer>
            }
            <RounderContainer
                style={{ background }}
                $radius={radius}
            >
                <IndentContainer $united={[8, 12]} data-test={'tooltip'}>
                    {content}
                </IndentContainer>
            </RounderContainer>
        </ST.TooltipContainer>
    );
});

TooltipBody.displayName = 'ForwardedTooltip';

export default TooltipBody;
